<div class="px-3 mt-4 mb-5 pb-5">

    <app-spinner *ngIf="load" [loading]="load" [text]="'LOAGING' | translate"></app-spinner>
    <app-error *ngIf="error" [title]="''"></app-error>

    <app-app-language></app-app-language>

    <div class="row mt-3" >
      <div [formGroup]="form" class="col-md-8">

        <div formArrayName="titles" class="row">
          <div *ngFor="let item of titles.controls; let i = index" [formGroupName]="i" class="col-md-12">
            <div *ngIf="item.get('language')?.value === selectedLanguage">

              <div class="input-group">
                <div class="border d-flex align-items-center">
                  <app-language-selector
                    [appId]="id"
                    [(ngModel)]="selectedLanguage"
                    [showName]="false"
                    [style]="false"
                    (languageChanged)="addLanguageField()"
                  ></app-language-selector>
                </div>
                 
                <div class="form-floating ">
                  <textarea class="form-control custom-textarea" formControlName="about" placeholder="{{ 'ABOUT' | translate }}" rows="5"></textarea>
                  <label for="about">{{ 'ABOUT' | translate }}</label>
                </div>

              </div>
              <div class="input-group mt-3">

                <div class="border d-flex align-items-center">
                  <app-language-selector
                    [appId]="id"
                    [(ngModel)]="selectedLanguage"
                    [showName]="false"
                    [style]="false"
                    (languageChanged)="addLanguageField()"
                  ></app-language-selector>
                </div>

                <div class="form-floating ">
                  <input type="text" class="form-control" formControlName="address" placeholder="{{ 'ADDRESS' | translate}}">
                  <label for="address">{{ "ADDRESS" | translate}}</label>
                </div>
              </div>
              
            </div>
          </div>
        </div>

        <!-- <app-app-phones id="{{id}}" [data]="phonesData" class="mt-3"></app-app-phones> -->
  
        <div formArrayName="phones" class="row">
          <div *ngFor="let phone of phones.controls; let i = index" [formGroupName]="i" class="col-md-12">
            <div class="input-group mb-3">
              <div class="form-floating">
                <input type="text" class="form-control" formControlName="phone" placeholder="Phone">
                <label for="phone">{{ 'PHONE' | translate }}</label>
              </div>
              <button type="button" class="btn btn-danger input-group-text" (click)="removePhone(i)">
                <i class="fi fi-rs-circle-xmark"></i>
              </button>
            </div>
          </div>
          <div>
            <button type="button" class="btn hover-color border d-flex" (click)="addPhone()">
              <i class="fi fi-rr-phone-plus mx-1"></i> {{ 'ADD_PHONE' | translate }}
            </button>
          </div>
        </div>
  
        <div formArrayName="socials" class="row mt-3">
          <div *ngFor="let social of socials.controls; let i = index" [formGroupName]="i" class="col-md-12">
            <div class="input-group mb-3">
              <div class="form-floating">
                <select class="form-control" formControlName="type">
                  <option *ngFor="let option of socialMediaTypes" [value]="option">{{ option }}</option>
                </select>
                <label for="type">{{"SELECT_SOCIAL_NETWORK" | translate }}</label>
              </div>
              <div class="form-floating">
                <input type="text" class="form-control" formControlName="link" placeholder="Social Media Link">
                <label for="link">{{"LINK" | translate}}</label>
              </div>
              <button type="button" class="btn btn-danger input-group-text" (click)="removeSocial(i)">
                  <i class="fi fi-rs-circle-xmark"></i>
              </button>
            </div>
          </div>
          <div>
            <button type="button" class="btn hover-color border d-flex" (click)="addSocial()">
              <i class="fi fi-rr-globe mx-1"></i> {{ 'ADD_SOCIAL' | translate }}
            </button>
          </div>
        </div>
        
        <div class="row mt-3">

          <div class="col-6">
            <div class="form-floating">
              <select class="form-control" formControlName="currency" [compareWith]="compareCurrencies">
                <option *ngFor="let currency of currencies" [ngValue]="currency">
                  <!-- <span [innerHTML]="currency?.logo"></span>  -->
                  {{ currency.name }} ({{ currency.code }})
                </option>
              </select>
              <label for="currency">{{"CHOOSE_CURRENCY" | translate}}</label>
            </div>
          </div>
        
          <div class="col-6">
            <div class="form-floating  col-6">
              <input type="color" class="form-control" formControlName="color" placeholder="{{ 'CHOOSE_COLOR' | translate }}">
              <label for="color">{{ 'CHOOSE_COLOR' | translate }}</label>
            </div>
           </div>

        </div>
      
  
        <div class="row mt-3">
          <div class="col-12">
            <app-logo-upload [logo]="logo" [load]="load" [id]="this.id"></app-logo-upload>
          </div>
        </div>

        <button *ngIf="fromSetup" type="button" (click)="skip()" class="btn  mt-3">
          <span >{{ 'SKIP' | translate }}</span>
        </button>
        <button type="button" (click)="update()" class="btn btn-lg btn-primary mt-3 d-flex" [disabled]="loadBtn">
          <app-spinner *ngIf="loadBtn" class="mx-2" [sm]="true"></app-spinner>
          <span *ngIf="!fromSetup">{{ 'SAVE' | translate }}</span>
          <span *ngIf="fromSetup">{{ 'FINISH' | translate }}</span>
        </button>

      </div>
    </div>
  </div>